import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useApp } from "../context/AppContext";
import GoogleButton from "../components/GoogleButton";

export default function Login() {
  const { t, login } = useApp();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setErr("");
    try {
      await login(email, password);
      toast.success(t.loginTitle);
      nav("/");
    } catch (e) {
      const detail = e?.response?.data?.detail;
      setErr(typeof detail === "string" ? detail : "Error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-[calc(100vh-70px)] grid place-items-center px-5 py-10">
      <div className="w-full max-w-md bg-white rounded-3xl border border-[#E7E0D5] p-8 shadow-[0_4px_24px_rgba(28,25,23,0.06)]">
        <h1 className="text-3xl font-bold text-stone-900 tracking-tight">{t.loginTitle}</h1>
        <p className="text-sm text-stone-600 mt-1">{t.loginToSave}</p>
        <div className="mt-6">
          <GoogleButton label={t.continueGoogle} />
        </div>
        <div className="flex items-center gap-3 my-5">
          <span className="flex-1 h-px bg-[#E7E0D5]" />
          <span className="text-xs uppercase tracking-widest font-mono text-stone-500">{t.orDivider}</span>
          <span className="flex-1 h-px bg-[#E7E0D5]" />
        </div>
        <form onSubmit={submit} className="space-y-4" data-testid="login-form">
          <FormField label={t.email}>
            <input data-testid="input-login-email" type="email" required value={email} onChange={(e)=>setEmail(e.target.value)} className="input-base" />
          </FormField>
          <FormField label={t.password}>
            <input data-testid="input-login-password" type="password" required value={password} onChange={(e)=>setPassword(e.target.value)} className="input-base" />
          </FormField>
          {err && <p className="text-sm text-[#B54708]" data-testid="login-error">{err}</p>}
          <button data-testid="button-login-submit" type="submit" disabled={loading} className="w-full py-3 rounded-full bg-[#D95338] hover:bg-[#C24127] text-white font-semibold active:scale-95 transition-all disabled:opacity-50">
            {loading ? "..." : t.login}
          </button>
        </form>
        <p className="text-sm text-stone-600 mt-6 text-center">
          {t.noAccount} <Link to="/register" data-testid="link-to-register" className="text-[#D95338] font-semibold hover:underline">{t.signup}</Link>
        </p>
      </div>
    </div>
  );
}

function FormField({ label, children }) {
  return (
    <label className="flex flex-col gap-1.5">
      <span className="text-xs uppercase tracking-wider font-mono font-medium text-stone-500">{label}</span>
      {children}
    </label>
  );
}
